export const theme = {
  colors: {
    // HyperLiquid Color Palette
    primary: '#20A67D',
    secondary: '#51D2C1',
    darkGray: '#273036',
    deepBlack: '#0E1A1E',
    white: '#FFFFFF',
    lightGray: '#8B9499',
    success: '#20A67D',
    warning: '#F59E0B',
    error: '#EF4444',
  },
  
  fonts: {
    mono: "'Space Mono', 'Courier New', monospace",
  },
  
  spacing: {
    xs: '0.5rem',
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem',
    xl: '3rem',
    '2xl': '4rem',
  },
  
  transitions: {
    fast: '0.2s ease',
    medium: '0.3s ease',
    slow: '0.5s ease',
  },
  
  borderRadius: {
    default: '8px',
    lg: '12px',
    round: '50%',
  },
  
  shadows: {
    sm: '0 2px 4px rgba(0, 0, 0, 0.1)',
    md: '0 4px 8px rgba(0, 0, 0, 0.2)',
    lg: '0 8px 16px rgba(0, 0, 0, 0.3)',
    glow: '0 0 20px rgba(32, 166, 125, 0.3)',
  },
  
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1200px',
  },
  
  zIndex: {
    modal: 1000,
    nav: 100,
    dropdown: 50,
  },
};
